"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.failureGetImmediateNodes = exports.successGetImmediateNodes = exports.loadingGetImmediateNodes = exports.requestGetImmediateNodes = void 0;

var _constants = require("./constants");

var requestGetImmediateNodes = function requestGetImmediateNodes(parents) {
  return {
    type: _constants.getImmediateNodesTypes.GET_IMMEDIATE_NODES_REQUEST,
    payload: {
      parents: parents
    }
  };
};

exports.requestGetImmediateNodes = requestGetImmediateNodes;

var loadingGetImmediateNodes = function loadingGetImmediateNodes() {
  return {
    type: _constants.getImmediateNodesTypes.GET_IMMEDIATE_NODES_LOADING
  };
};

exports.loadingGetImmediateNodes = loadingGetImmediateNodes;

var successGetImmediateNodes = function successGetImmediateNodes(immediateNodes, immediateNodesPagination) {
  return {
    type: _constants.getImmediateNodesTypes.GET_IMMEDIATE_NODES_SUCCESS,
    payload: {
      immediateNodes: immediateNodes,
      immediateNodesPagination: immediateNodesPagination
    }
  };
};

exports.successGetImmediateNodes = successGetImmediateNodes;

var failureGetImmediateNodes = function failureGetImmediateNodes(reason) {
  return {
    type: _constants.getImmediateNodesTypes.GET_IMMEDIATE_NODES_FAILURE,
    payload: {
      error: reason
    }
  };
};

exports.failureGetImmediateNodes = failureGetImmediateNodes;